import React, {Component} from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import {StateWrapper} from '../form-validator';
import Cleave from 'cleave.js/react';
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.us'; // do not remove

/**
 * Text field for Bootstrap Material design.
 *
 */
class TextField extends Component {
    render() {
        // Note that validations is not used here directly,
        // But we have to reference it, so rest does not have.
        // We could have removed it with delete statements also.
        const {
                // 
                name, type, placeholder, description,
                className, iconClass, labelClass,
                rightSideSpanClass,
                // extract validations so it does not go into rest
                validations,
                // These values are injected by StateWrapper
                value, onChange, onBlur, validationState,
                // options used by the Cleave component to setup input auto format patterns
                cleaveOptions,
                children,
                helpText,
                ...rest
            } = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);
        const mdForm = (className || '').startsWith('md-form');
        if (mdForm) {
            return (
                <div className={className}>
                    {iconClass && <i className={iconClass}/>}
                    {cleaveOptions ?
                        <Cleave
                            options={cleaveOptions}
                            type={type || 'text'}
                            name={name}
                            className={classNames("form-control", {'is-invalid': hasError})}
                            id={name}
                            value={value || ''}
                            placeholder={placeholder}
                            onChange={onChange}
                            onBlur={onBlur}
                            aria-describedby={"sr-" + name}
                            aria-invalid={hasError}
                            {...rest}
                        />
                        :
                        <input
                            type={type || 'text'}
                            name={name}
                            className={classNames("form-control", {'is-invalid': hasError})}
                            id={name}
                            value={value || ''}
                            placeholder={placeholder}
                            onChange={onChange}
                            onBlur={onBlur}
                            aria-describedby={"sr-" + name}
                            aria-invalid={hasError}
                            {...rest}
                        />
                    }
                    <label htmlFor={name} className={classNames("active", labelClass)}>
                        {/* label content can be simple text or function */}
                        {typeof description === 'function' ? description() : description}
                    </label>
                    {rightSideSpanClass && <span className={rightSideSpanClass}></span>}
                    {/* This is an acceptable place to inject additional widgets
                      intended to extend the input field.
                      Use react children for this.
                    */}
                    {children}
                    {
                        helpText &&
                        <div dangerouslySetInnerHTML={{__html: helpText}}></div>
                    }
                    <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                         aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                        {
                            hasError && messages.map(
                                item => (
                                    <div key={item}>
                                        {item}
                                    </div>
                                ))
                        }
                    </div>
                </div>
            );
        }
        return (
            <div className={className || "col-md-6 mb-3"}>
                <label htmlFor={name}>
                    {description}
                </label>
                <input type={type || 'text'}
                       name={name}
                       className={classNames("form-control", {'is-invalid': hasError})}
                       id={name}
                       value={value || ''}
                       placeholder={placeholder}
                       onChange={onChange}
                       onBlur={onBlur}
                       aria-describedby={"sr-" + name}
                       aria-invalid={hasError}
                       {...rest}
                />

                {
                    helpText &&
                    <div dangerouslySetInnerHTML={{__html: helpText}}></div>
                }
                <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                     aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                    {
                        hasError && messages.map(
                            item => (
                                <div key={item}>
                                    {item}
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

TextField.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func
    ]),
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    helpText: PropTypes.string
};

export default StateWrapper(TextField);